// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2ProcessingOutcomeModel {
    static getAttributeTypeMap() {
        return EnrollmentV2ProcessingOutcomeModel.attributeTypeMap;
    }
}
EnrollmentV2ProcessingOutcomeModel.discriminator = undefined;
EnrollmentV2ProcessingOutcomeModel.additionalProperties = false;
EnrollmentV2ProcessingOutcomeModel.attributeTypeMap = [
    {
        "name": "eligibility",
        "baseName": "eligibility",
        "type": "EnrollmentEligibility"
    },
    {
        "name": "scenario",
        "baseName": "scenario",
        "type": "EnrollmentScenario"
    },
    {
        "name": "existingEnrollmentId",
        "baseName": "existingEnrollmentId",
        "type": "number"
    },
    {
        "name": "enrollmentMessageDeterminations",
        "baseName": "enrollmentMessageDeterminations",
        "type": ""
    },
];
//# sourceMappingURL=enrollmentV2ProcessingOutcomeModel.js.map